import { Hidden, Paper } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../modules';
import React, { Component, Fragment } from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import AccountsPane from './AccountsPane';
import AuthenticationsPane from './AuthenticationsPane';
import BindingsPane from './BindingsPane';
import OverviewPane from './OverviewPane';
import PayeesPane from './PayeesPane';
import PibMenu from '../common/PibMenu';
import TransferPane from './TransferPane';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { logout } from '../../modules/auth';
import { proxyBase } from '../../modules/config';
import { push } from 'connected-react-router';

const styles = (theme: Theme) => createStyles({
  root: {
    flex: '1',
    display: 'flex',
    paddingTop: theme.spacing(2),
  },
  pibMenu: {
    flex: `0 0 30%`,
    marginRight: theme.spacing(2),
    '& > *': {
      marginBottom: theme.spacing(3)
    }
  },
  pibMain: {
    flex: '1 1 auto',
    '& > *': {
      marginBottom: theme.spacing(3)
    }
  },
}
)

type State = {
}

class PIBContainer extends Component<Props, State> {
  render() {
    const { classes, match, proxyBase } = this.props;

    if (!this.props.auth.authenticated) {
      return <Redirect to={proxyBase()} />
    }

    return (
      <Fragment>
        <div className={classNames(classes.root, 'maxWidth')}>
          <Hidden smDown>
            <div className={classes.pibMenu}>
              <Paper>
                <PibMenu />
              </Paper>
            </div>
          </Hidden>
          <div className={classes.pibMain}>
            <Switch>
              <Route path={match.path + '/overview'} component={OverviewPane} />
              <Route path={match.path + '/accounts'} component={AccountsPane} />
              <Route path={match.path + '/transfer'} component={TransferPane} />
              <Route path={match.path + '/bindings'} component={BindingsPane} />
              <Route path={match.path + '/payees'} component={PayeesPane} />
              <Route path={match.path + '/authentications'} component={AuthenticationsPane} />
            </Switch>
          </div>
        </div>
      </Fragment>
    )
  }
}



const mapStateToProps = ({ auth, intl }: IStoreState) => ({
  auth,
  intl,
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      push,
      logout,
      proxyBase
    }, dispatch
  )

interface MatchParams {
  url: string;
}

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, RouteComponentProps<MatchParams> {

}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PIBContainer));